module.exports = __webpack_public_path__ + "static/media/ic-nav-overview-inactive.5eeaec2c.svg";